module.exports = __webpack_public_path__ + "media/images/jira-2a8a03f7eec4199b046f77e752c3b71d.png";